import React, { useRef, useState } from "react";

const JobPostItem = ({ post }) => {
    const [isOpen, setIsOpen] = useState(false);
    const itemRef = useRef(null);
    const contentId = `job-content-${post.id}`;

    const handleOpen = () => {
        const nextState = !isOpen;
        setIsOpen(nextState);

        if (nextState) {
            window.scrollTo({
                top: itemRef.current.getBoundingClientRect().top + window.scrollY - 100,
                behavior: "smooth",
            });
        }
    };

    return (
        <li
            className="careers__job-item"
            ref={itemRef}
            aria-expanded={isOpen}
            aria-controls={contentId}
        >
            <div onClick={handleOpen} className="careers__job-item-inner">
                <div>
                    <h5>{post.title}</h5>
                    <time dateTime={post.date} className="p">
                        {post.date}
                    </time>
                </div>

                <div className="careers__job-item-details">
                    {post.department && post.department.length > 0 && (
                        <div className="h6">{post.department.join(", ")}</div>
                    )}
                    {post.country && post.country.length > 0 && (
                        <div className="p">{post.country.join(", ")}</div>
                    )}
                </div>

                <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={contentId}
                    aria-label={isOpen ? "Collapse job details" : "Expand job details"}
                >
                    {isOpen ? (
                        <svg
                            className="careers__close-icon"
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <rect
                                x="0.5"
                                y="0.5"
                                width="47"
                                height="47"
                                rx="23.5"
                                stroke="#D9D9D9"
                            />
                            <path
                                d="M20 20L28 28M20 28L28 20"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    ) : (
                        <svg
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                        >
                            <rect width="48" height="48" rx="24" fill="#20A097" />
                            <path
                                d="M19.333 24.0003L28.6663 24.0003M23.9997 28.667L23.9997 19.3337"
                                stroke="white"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                </button>
            </div>

            <div
                className="careers__job-item-content"
                id={contentId}
                style={{
                    gridTemplateRows: isOpen ? "1fr" : "0fr",
                }}
                aria-hidden={!isOpen}
            >
                <div>
                    <div dangerouslySetInnerHTML={{ __html: post.content }} />
                    <a
                        href={post.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="button button--primary"
                    >
                        <span className="ellipse"></span>
                        <span className="ellipse"></span>
                        <span className="ellipse"></span>
                        <span className="title">Apply now</span>
                    </a>
                </div>
            </div>
        </li>
    );
};

export default JobPostItem;
